import { FormattedMessage } from "react-intl";
import { Controller } from "react-hook-form";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

interface IReactHookFormSelect {
  name: string;
  control: any;
  defaultValue?: boolean;
}

const ReactHookFormSelect = ({
  name = "test",
  control = () => null,
  defaultValue = false,
}: IReactHookFormSelect): JSX.Element => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => (
        <FormControlLabel
          control={
            <Checkbox
              onBlur={onBlur} // notify when input is touched
              onChange={onChange} // send value to hook form
              checked={value}
              inputRef={ref}
            />
          }
          label={<FormattedMessage id={`forms.${name}.label`} />}
        />
      )}
    />
  );
};
export default ReactHookFormSelect;
